import { Box, Skeleton } from '@mui/material';

interface Props {
  /** Fixed block height for chart widgets; omit for a stacked-rows list/table look. */
  height?: number;
  /** Number of placeholder rows for the list/table variant. */
  rows?: number;
}

/**
 * Shared loading placeholder so every Reporting 2.0 widget loads with the same
 * skeleton treatment (matching the KPI strip) instead of a mix of spinners and
 * "Loading…" text. Charts pass a `height`; lists/tables use the row variant.
 */
const WidgetSkeleton = ({ height, rows = 5 }: Props) => {
  if (height != null) {
    return <Skeleton variant='rounded' height={height} sx={{ borderRadius: 2 }} />;
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} variant='rounded' height={20} sx={{ borderRadius: 1 }} />
      ))}
    </Box>
  );
};

export default WidgetSkeleton;
